import { ROLES } from '@/shared/constants/roles';

export const chatRoutes = [
  {
    path: 'qna',
    name: 'qna',
    component: () => import('./views/QnAView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
];
